import axios from 'axios';
import http from 'http';
import https from 'https';

import tracer from './tracer';

const instance = axios.create({
    httpAgent: new http.Agent({
        keepAlive: true,
    }),

    httpsAgent: new https.Agent({
        keepAlive: true,
        rejectUnauthorized: false,
    }),

    transformResponse: res => res,
});

/**
 * Replace Algolia Requester by a simple Axios client
 * @returns {{destroy(): Promise<void>, send(*=): Promise<unknown>}|Promise<unknown>|Promise<void>}
 */
export default function createAxiosRequesterWithGzip() {
    return {
        send(request) {
            // console.log('send algolia data', request);

            return tracer.trace('algolia.send.axios', () => {
                return new Promise(resolve => {
                    instance({
                        method: request.method,
                        url: request.url,
                        headers: request.headers,
                        data: request.data,
                        timeout: process.env.ALGOLIA_TIMEOUT || 2000,
                        transformRequest: data => {
                            const parsedData = JSON.parse(data);
                            /**
                             * We can safely remove the second/last request :
                             * It is actually hardcoded by react-instansearch and we don't care about it…
                             * at all !
                             * No impact on search pages as there is only 1 query (as it should be)
                             */
                            if (parsedData.requests.length > 1) {
                                parsedData.requests.pop();
                                return JSON.stringify(parsedData);
                            }
                            return data;
                        },
                        transformResponse: res => {
                            return res;
                        },
                    })
                        .then(function(response) {
                            resolve({
                                status: response.status || 0,
                                content: response.data,
                                isTimedOut: false,
                            });
                        })
                        .catch(function(error) {
                            resolve({
                                status: 0,
                                content: error.message,
                                isTimedOut: false,
                            });
                        });
                });
            });
        },
        destroy() {
            return Promise.resolve();
        },
    };
}
